export default __webpack_public_path__ + "static/media/gondola-banner.d94576ab.jpg";